import { Panel } from '@/components/Bicester';
import Table, { Cell } from '@/components/Bicester/Table';
import { DateTimeCell, LevelCell, OperationCell } from '@/components/Bicester/Table/Cells';
import { LEVEL_TYPE, ROLE_TYPE } from '@/constants';
import useContentHeight from '@/hooks/useContentHeight';
import usePrefix from '@/hooks/usePrefix';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { push } from '@/utils/history';
import _ from 'lodash';
import React from 'react';
import { ACCOUNT_TABS, CAToolbarContext } from '.';

const CustomerAccountList = () => {
  const { profile } = useReadyInfo();
  const { prefix, classname } = usePrefix('bicester-customer-list');

  const { listLoading, listData, onChange } = React.useContext(CAToolbarContext);

  return (
    <div className={classname}>
      <Panel
        title="客户列表"
        subTitle={`总计 ${listData?.total || 0} 条`}
        style={{
          paddingBottom: 0,
          height: 'calc(100vh - var(--headerHeight) - var(--navBarHeight) - var(--toolBarHeight))',
        }}
        loading={listLoading}
      >
        <Table
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
          pageInfo={{ page: listData?.current_page, total: listData?.total }}
          data={listData?.member_list ?? []}
          columns={[
            {
              columnProps: {
                flexGrow: 2,
              },
              header: '客户名',
              cell: <Cell dataKey="name" />,
            },
            {
              columnProps: {
                flexGrow: 2,
              },
              header: '会员号',
              cell: <Cell dataKey="user_code" />,
            },
            {
              columnProps: {
                flexGrow: 1,
              },
              header: '性别',
              cell: <Cell dataKey="sex" />,
            },
            {
              columnProps: {
                flexGrow: 3,
              },
              header: '手机号',
              cell: <Cell dataKey="phone" />,
            },
            {
              columnProps: {
                flexGrow: 2,
              },
              header: '会员等级',
              cell: <LevelCell dataKey="level" />,
            },
            {
              columnProps: {
                flexGrow: 3,
              },
              header: '会员到期时间',
              cell: <DateTimeCell dataKey="valid_level_time" format="YYYY/MM/DD" />,
            },
            {
              columnProps: {
                flexGrow: 3,
              },
              header: '城市',
              cell: <Cell dataKey="city" />,
            },
            {
              columnProps: {
                flexGrow: 1,
              },
              header: '详情',
              cell: (
                <OperationCell
                  onClick={(rowData) => {
                    const { id, level } = rowData;
                    push(
                      `/customer-account/${
                        level === LEVEL_TYPE.NOT ? ACCOUNT_TABS.NO_MEMBER : ACCOUNT_TABS.MEMBER
                      }/detail/${id}`
                    );
                  }}
                />
              ),
            },
          ].filter(
            /**
             * GE兼职：没有详情列
             */
            (column) => !(profile?.role === ROLE_TYPE.PT && column.header === '详情')
          )}
          onChange={onChange}
        >
          <Table.Body
            height={
              useContentHeight({
                withToolBar: true,
                withPanelPaddingTop: true,
                withPanelHeader: true,
              }) - 62
            }
            style={{
              borderBottom: '2px solid var(--dividerBgColor)',
              boxSizing: 'content-box',
            }}
            bodyEmpty="当前无客户列表，请在右上角完成搜索"
          />
          <Table.Pagination style={{ height: 60, justifyContent: 'center', marginTop: 0 }} />
        </Table>
      </Panel>
    </div>
  );
};

export default CustomerAccountList;
